import { logEvent } from "firebase/analytics";
import { analytics } from "./firebaseConfig";
import { ANALYTICS_EVENTS, PRODUCT_ANALYTICS } from "./AnalyticsConstants";

/**
 * Generic event tracker
 */
export const trackEvent = (eventName, params = {}) => {
  if (!analytics) return;

  logEvent(analytics, eventName, {
    ...params,
    ...(process.env.NODE_ENV === "development" && {
      debug_mode: true,
    }),
  });
};

/**
 * Track page views
 */
export const trackPageView = (
  pageName = PRODUCT_ANALYTICS.PAGE_PRODUCTS,
  productName = PRODUCT_ANALYTICS.PRODUCT_NAME
) => {
  trackEvent(ANALYTICS_EVENTS.PAGE_VIEW, {
    page_name: pageName,
    product_name: productName,
  });
};

/**
 * Track button clicks
 */
export const trackButtonClick = (buttonName, productName = "") => {
  trackEvent("button_click", {
    button_name: buttonName,
    product_name: productName,
  });
};

/**
 * Track product views
 */
export const trackProductView = (
  productName = PRODUCT_ANALYTICS.PRODUCT_NAME
) => {
  trackEvent(ANALYTICS_EVENTS.PRODUCT_VIEW, {
    product_name: productName,
  });
};

/**
 * Track product actions
 */
export const trackProductAction = (
  productName = PRODUCT_ANALYTICS.PRODUCT_NAME,
  action = PRODUCT_ANALYTICS.ACTION_REQUEST_TO_BUY
) => {
  trackEvent(ANALYTICS_EVENTS.PRODUCT_ACTION, {
    product_name: productName,
    action,
  });
};